module.exports = __webpack_public_path__ + "img/calendar-tile-bg-3.bb926b6c.png";